import "./section-four-access-restricted.scss";

export const SectionFourAccessRestricted = () => {
  return (
    <div className="section-four-access-restricted">
      <p className="section-four-access-restricted__paragraph">
        Доступ к данным и функционалу раздела ограничен.
      </p>
      <p className="section-four-access-restricted__paragraph">
        Для открытия доступа добавьте в титульный лист свою организацию в один
        из блоков:
      </p>
      <p className="section-four-access-restricted__paragraph">
        застройщик, эксплуатирующая организации, региональный оператор,
        <br />
        технический заказчик,
        <br />
        лицо осуществляющее подготовку проектной документации,
        <br />
        авторский надзор,
        <br />
        лицо осуществляющее строительство.
      </p>
    </div>
  );
};
